import {
  ADDED,
  LOADED,
  DELETED,
  UPDATEING,
  UPDATED,
} from "./actionType";

export const added = (book) => {
  return {
    type: ADDED,
    payload: book,
  };
};

export const loaded = (books) => {
  return {
    type: LOADED,
    payload: books,
  };
};

export const updated = (book) => {
  return {
    type: UPDATED,
    payload: book,
  };
};

export const updatingBookInfo = (book) => {
  return {
    type: UPDATEING,
    payload: book,
  };
};

export const deleted = (bookId) => {
  return {
    type: DELETED,
    payload: bookId,
  };
};
